import * as styles from './PostListContainer.module.css'

function PostListContainer({ children }) {
  return <div className={styles.PostListContainer}>{children}</div>
}

export default PostListContainer
